import { render } from "./UserMessages.vue?vue&type=template&id=faeb2e86&scoped=true"
import script from "./UserMessages.vue?vue&type=script&lang=js"
export * from "./UserMessages.vue?vue&type=script&lang=js"

import "./UserMessages.vue?vue&type=style&index=0&id=faeb2e86&scoped=true&lang=css"

import exportComponent from "C:\\Users\\PamelaOsunza\\OneDrive - dermapp.com\\Escritorio\\dermapp\\dermapp-pacientes-staging\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-faeb2e86"]])

export default __exports__